'use strict';
// This file is auto generated by bin/create-constants.js
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  chain: 'link',
  'comment-o': 'comments',
  'comments-o': 'comments',
  contact: 'contacts',
  copy: 'duplicate',
  'external-link': 'externalLink',
  eye: 'view',
  pencil: 'edit',
  photo: 'insertImage',
  'upload-light': 'upload',
  'warning-triangle': 'warning'
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/icons/static-2.400/js/iconAliases.js
// module id = 461
// module chunks = 177